var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.957 19.82s-.066 0 0 0h-5.775v-5.776c0-.656-.525-1.115-1.182-1.115-.656 0-1.115.525-1.115 1.181v5.775H14.11c-.656 0-1.116.525-1.116 1.181 0 .657.525 1.116 1.181 1.116h5.775v5.775c0 .656.525 1.116 1.182 1.116.656 0 1.115-.526 1.115-1.182v-5.775h5.775c.657 0 1.116-.525 1.116-1.181-.066-.59-.59-1.116-1.181-1.116Z",
    fill: "#163144"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 .854A20.11 20.11 0 0 0 .854 21c0 11.157 8.99 20.213 20.146 20.213 11.157 0 20.213-9.056 20.213-20.213C41.213 9.844 32.157.854 21 .854Zm0 38.062c-9.843 0-17.85-8.072-17.85-17.916 0-9.843 8.007-17.85 17.85-17.85 9.844 0 17.916 8.007 17.916 17.85 0 9.844-8.072 17.916-17.916 17.916Z",
    fill: "#163144"
  })));
};
export default SvgPlusCircle;